<template>
  <div class="home">
    <FilterLayout v-model="searchForm" @onSubmit="onSubmit">
      <el-col :md="5" :sm="12">
        <el-form-item label="筛选" prop="account_name">
          <el-input v-model.trim="searchForm.account_name" placeholder="渠道号" />
        </el-form-item>
      </el-col>
      <el-col :md="5" :sm="12">
        <el-form-item label="App名称" prop="app_id">
          <SelectApp v-model="searchForm.app_id"></SelectApp>
        </el-form-item>
      </el-col>
      <el-col :md="5" :sm="12">
        <el-form-item label="广告平台" prop="platform">
          <el-select v-model="searchForm.platform" filterable clearable multiple collapse-tags
            :popper-append-to-body="false" placeholder="请选择">
            <el-option v-for="item in platform" :key="item.id" :label="item.title" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-button slot="ggwgl" type="primary" @click="openPassback">批量回传控制</el-button>
    </FilterLayout>
    <TableLayout :column="column" :data="tableData.data" :total="tableData.total" :loading="tableData.loading"
      :currentPage="tableOpt.currentPage" @sizeChange="onSizeChange" @pageChange="onPageChange">
      <template #system="row">{{ row.row.system | formatSystem }}</template>

      <template #time_update="row">{{
        $moment(parseInt(row.row.time_update * 1000)).format(
          "YYYY-MM-DD HH:mm:ss"
        )
      }}</template>

      <template #option="row">
        <el-button size="small" @click="onShowEdit(row.row)" v-if="row.row.back_control">编辑回传</el-button>
        <el-popconfirm title="确定改变这条数据？" @confirm="onConfirm(row.row)" style="margin-left: 15px">
          <el-switch v-if="row.row.back_control" slot="reference" :value="row.row.status == 1 ? true : false"
            inactive-color="#ff4949" active-color="#13ce66"></el-switch>
        </el-popconfirm>
      </template>
    </TableLayout>

    <!-- 编辑回传弹窗 -->
    <el-dialog :title="editFormTitle" :visible.sync="showEditForm">
      <div v-if="myEventId" class="">
        <span class="hcbl_title" style="padding:10px 0">
          行为ID
          <span class="hcbl_title" style="margin-left: 30px">{{ myEventId === "0" ||
            !myEventId ? "未绑定" : myEventId }}</span>
        </span>
      </div>
      <el-form label-width="0px" ref="myform">
        <el-form-item>
          <el-switch active-text="回传激活设备" v-model="editForm.active"
            @change="changOnSwi('active', 'activeBackhaulType', 'activeBackhaulBehaviorType', 'active_behavior_options')"></el-switch>
          <span class="hcbl_title" style="margin-left: 58px">回传比例
            <el-input class="back-money" :min="0" :max="100" type="number" v-model="editForm.a" @input="changeNum"
              @blur="
                editForm.a === ''
                  ? (editForm.a = 100)
                  : (editForm.a = editForm.a)
                " />%
          </span>
          <!-- 回传类型 -->
          <div class="form-item-child" v-if="editForm.active">
            <span class="hcbl_title" style="padding:10px 0">
              <span class="hcbl_title" style="margin-right: 14px">回传类型</span>
              <!-- 回传选择 -->
              <el-select class="back-money" style="width:180px" v-model="editForm.activeBackhaulType"
                @change="changeSwi('activeBackhaulBehaviorType')" placeholder="请选择">
                <el-option v-for="item in type_options" :key="item.value" :label="item.label" :value="item.val">
                </el-option>
                <el-popover placement="right" width="100" trigger="hover">
                  <div>如果开启API映射回传则需要部门对接中台映射回传接口，开发相应功能</div>
                  <el-option :label="mapping_val.label" :value="mapping_val.val" slot="reference">
                  </el-option>
                </el-popover>
              </el-select>
              <!-- 行为选择 -->
              <el-select class="back-money" v-if="editForm.activeBackhaulType === '3'" style="width:180px"
                v-model="editForm.activeBackhaulBehaviorType" placeholder="请选择标准行为" @change="changeSelectDis">
                <el-option v-for="item in active_behavior_options" :disabled="item.disabled" :key="item.val"
                  :label="item.label" :value="item.val">
                </el-option>
              </el-select>
            </span>
            <!-- 计划ID -->
            <div class="program-id-wrapper">
              <span class="hcbl_title" style="width: 90px;">计划ID</span>
              <el-input type="textarea" v-model="editForm.back_active_bind_aid" placeholder="请使用回车分割！" :rows="4"
                style="width: 600px;"></el-input>
            </div>
            <div v-if="editForm.activeBackhaulType !== '1'" style="padding: 10px 0">
              <span>
                <span class="hcbl_title">自定义回传时间</span>
                <el-input class="back-money" :min="1" type="number" v-model="editForm.active_timeNum"
                  @input="changeActiveTime" />
                <el-select class="back-money" v-model="editForm.active_time" placeholder="请选择">
                  <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </span>
            </div>
          </div>
        </el-form-item>
        <el-form-item>
          <el-switch active-text="回传次日留存设备" v-model="editForm.keep"
            @change="changOnSwi('keep', 'keepBackhaulType', 'keepBackhaulBehaviorType', 'keep_behavior_options')"></el-switch>
          <span class="hcbl_title" style="margin-left: 30px">回传比例
            <el-input class="back-money" :min="0" :max="100" type="number" v-model="editForm.b" @input="changeNum2"
              @blur="
                editForm.b === ''
                  ? (editForm.b = 100)
                  : (editForm.b = editForm.b)
                " />%
          </span>

          <!-- 回传类型 -->
          <div class="form-item-child" v-if="editForm.keep">
            <span class="hcbl_title" style="padding:10px 0">
              <span class="hcbl_title" style="margin-right: 14px">回传类型</span>
              <!-- 回传选择 -->
              <!--  <el-select class="back-money" style="width:180px" v-model="editForm.keepBackhaulType"
                @change="changeSwi('keepBackhaulBehaviorType')" placeholder="请选择">
                <el-option label="普通回传" value="1">
                </el-option>
                                <el-popover placement="right" width="100" trigger="hover">
                  <div>如果开启API映射回传则需要部门对接中台映射回传接口，开发相应功能</div>
                  <el-option :label="mapping_val.label" :value="mapping_val.val" slot="reference">
                  </el-option>
                </el-popover>
              </el-select> -->
              <el-select class="back-money" style="width:150px" v-model="editForm.keepBackhaulType"
                @change="changeSwi('keepBackhaulBehaviorType')" placeholder="请选择">
                <el-option v-for="item in type_options" :key="item.val" :label="item.label" :value="item.val">
                </el-option>
                <el-popover placement="right" width="100" trigger="hover">
                  <div>如果开启API映射回传则需要部门对接中台映射回传接口，开发相应功能</div>
                  <el-option :label="mapping_val.label" :value="mapping_val.val" slot="reference">
                  </el-option>
                </el-popover>
              </el-select>

              <!-- 行为选择 -->
              <el-select class="back-money" v-if="editForm.keepBackhaulType === '3'" style="width:180px"
                v-model="editForm.keepBackhaulBehaviorType" placeholder="请选择标准行为" @change="changeSelectDis">
                <el-option v-for="item in keep_behavior_options" :disabled="item.disabled" :key="item.val"
                  :label="item.label" :value="item.val">
                </el-option>
              </el-select>
              <!-- 生效时间 -->
              <div v-if="editForm.keepBackhaulType !== '1'" style="padding: 10px 0">
                <span>
                  <span class="hcbl_title">自定义回传时间</span>
                  <el-input class="back-money" :min="1" type="number" v-model="editForm.keep_timeNum"
                    @input="changeKeepTime" />
                  <el-select class="back-money" v-model="editForm.keep_time" placeholder="请选择">
                    <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </span>
              </div>
              <!-- 回传开关 -->
              <div>
                <el-tooltip class="item" effect="dark" content="开启开关，回传次留时将会校验此设备激活是否已回传，如已回传，才会回传次留，反之则不回传次留"
                  placement="right">
                  <i class="el-icon-info" style="font-size: 12px"></i>
                </el-tooltip>
                激活回传校验
                &ensp;<el-switch v-model="editForm.activation_check"></el-switch>
              </div>
            </span>

            <!-- 计划ID -->
            <div class="program-id-wrapper">
              <span class="hcbl_title" style="width: 90px;">计划ID</span>
              <el-input v-model="editForm.back_keep_bind_aid" placeholder="请使用回车分割！" :rows="4" type="textarea"
                style="width: 600px;"></el-input>
            </div>
          </div>
        </el-form-item>
        <el-form-item>
          <el-switch active-text="回传付费设备" v-model="editForm.pay"
            @change="changOnSwi('pay', 'payBackhaulType', 'payBackhaulBehaviorType', 'pay_behavior_options')"></el-switch>
          <span class="hcbl_title" style="margin-left: 58px">回传比例
            <el-input class="back-money" :min="0" :max="100" type="number" v-model="editForm.c" @input="changeNum3"
              @blur="
                editForm.c === ''
                  ? (editForm.c = 100)
                  : (editForm.c = editForm.c)
                " />%
          </span>

          <div v-show="editForm.pay" class="form-item-child">
            <!-- 回传类型 -->
            <div v-if="editForm.pay">
              <span class="hcbl_title" style="padding:10px 0">
                <span class="hcbl_title" style="margin-right: 14px">回传类型</span>
                <!-- 回传选择 -->
                <el-select class="back-money" style="width:180px" v-model="editForm.payBackhaulType"
                  @change="changeSwi('payBackhaulBehaviorType')" placeholder="请选择">
                  <el-option v-for="item in type_options" :key="item.val" :label="item.label" :value="item.val">
                  </el-option>
                  <el-popover placement="right" width="100" trigger="hover">
                    <div>如果开启API映射回传则需要部门对接中台映射回传接口，开发相应功能</div>
                    <el-option :label="mapping_val.label" :value="mapping_val.val" slot="reference">
                    </el-option>
                  </el-popover>
                </el-select>
                <!-- 行为选择 -->
                <el-select class="back-money" v-if="editForm.payBackhaulType === '3'" style="width:180px"
                  v-model="editForm.payBackhaulBehaviorType" placeholder="请选择标准行为" @change="changeSelectDis">
                  <el-option v-for="item in pay_behavior_options" :disabled="item.disabled" :key="item.val"
                    :label="item.label" :value="item.val">
                  </el-option>
                </el-select>
              </span>

              <!-- 计划ID -->
              <div class="program-id-wrapper">
                <span class="hcbl_title" style="width: 90px;">计划ID</span>
                <el-input v-model="editForm.back_pay_bind_aid" placeholder="请使用回车分割！" :rows="4" type="textarea"
                  style="width: 600px;"></el-input>
              </div>

            </div>
            <!-- 订单类型 -->
            <div style="padding: 10px 0" v-if="editForm.payBackhaulType == '1'">
              <span class="hcbl_title">
                <span class="hcbl_title" style="margin-right: 14px">订单类型</span>
                <el-select v-model="editForm.order_callback_type" placeholder="请选择">
                  <el-option v-for="item in orderCallbackType" :key="item.val" :label="item.label" :value="item.val">
                  </el-option>
                </el-select>
              </span>
            </div>
            <!-- 自定义回传时间 -->
            <div style="padding: 10px 0">
              <span class="hcbl_title">
                <span class="hcbl_title" style="margin-right: 14px">自定义回传时间</span>
                <el-input class="back-money" :min="1" type="number" v-model="editForm.d" @input="changeTimeNum" />
                <el-select class="back-money" v-model="editForm.time" placeholder="请选择">
                  <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </span>
            </div>
            <!-- 订单金额 -->
            <div v-if="editForm.payBackhaulType == '1'">
              <span class="hcbl_title" style="margin-right: 28px">订单金额大于</span>
              <el-input class="back-money" type="number" v-model.trim="editForm.pay_money" />元时回传
            </div>
            <div style="padding-top: 10px" v-if="editForm.payBackhaulType === '1'">
              <span class="hcbl_title">回传订单金额比例</span>
              <el-input class="back-money" type="number" v-model.trim="editForm.pay_detail" @input="changePayDetail" />
              %
              <span class="title">比例为0时表示不回传订单金额</span>
            </div>
          </div>

          <div v-if="platformFlag == '腾讯广告' || platformFlag == '优酷-新睿视'">
            <el-switch active-text="回传下单设备" v-model="editForm.order"
              @change="changOnSwi('order', 'orderBackhaulType', 'orderBackhaulBehaviorType', 'order_behavior_options')"></el-switch>
            <span class="hcbl_title" style="margin-left: 58px">回传比例
              <el-input class="back-money" :min="0" :max="100" type="number" v-model="editForm.order_c"
                @input="changeNum4" @blur="
                  editForm.order_c === ''
                    ? (editForm.order_c = 100)
                    : (editForm.order_c = editForm.order_c)
                  " />%
            </span>
            <div v-show="editForm.order" class="form-item-child">
              <!-- 回传类型 -->
              <div v-if="editForm.order">
                <span class="hcbl_title" style="padding:10px 0">
                  <span class="hcbl_title" style="margin-right: 14px">回传类型</span>
                  <!-- 回传选择 -->
                  <el-select class="back-money" style="width:180px" v-model="editForm.orderBackhaulType"
                    @change="changeSwi('orderBackhaulBehaviorType')" placeholder="请选择">
                    <el-option v-for="item in type_options" :key="item.val" :label="item.label" :value="item.val">
                    </el-option>
                    <el-popover placement="right" width="100" trigger="hover">
                      <div>如果开启API映射回传则需要部门对接中台映射回传接口，开发相应功能</div>
                      <el-option :label="mapping_val.label" :value="mapping_val.val" slot="reference">
                      </el-option>
                    </el-popover>
                  </el-select>
                  <!-- 行为选择 -->
                  <el-select class="back-money" v-if="editForm.orderBackhaulType === '3'" style="width:180px"
                    v-model="editForm.orderBackhaulBehaviorType" placeholder="请选择标准行为" @change="changeSelectDis">
                    <el-option v-for="item in order_behavior_options" :disabled="item.disabled" :key="item.val"
                      :label="item.label" :value="item.val">
                    </el-option>
                  </el-select>
                </span>
                <!-- 计划ID -->
                <div class="program-id-wrapper">
                  <span class="hcbl_title" style="width: 90px;">计划ID</span>
                  <el-input v-model="editForm.create_order_bind_aid" placeholder="请使用回车分割！" :rows="4" type="textarea"
                    style="width: 600px;"></el-input>
                </div>
              </div>
              <!-- 自定义回传时间 -->
              <div style="padding: 10px 0">
                <span class="hcbl_title">
                  <span class="hcbl_title" style="margin-right: 14px">自定义回传时间</span>
                  <el-input class="back-money" :min="1" type="number" v-model="editForm.order_d"
                    @input="changeTimeNumPlaceOrder" />
                  <el-select class="back-money" v-model="editForm.time_order" placeholder="请选择">
                    <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </span>
              </div>
              <!-- 订单金额 -->
              <div v-if="editForm.orderBackhaulType == '1'">
                <span class="hcbl_title" style="margin-right: 28px">订单金额大于</span>
                <el-input class="back-money" type="number" v-model.trim="editForm.order_money" />元时回传
              </div>
              <div style="padding-top: 10px" v-if="editForm.orderBackhaulType === '1'">
                <span class="hcbl_title">回传订单金额比例</span>
                <el-input class="back-money" type="number" v-model.trim="editForm.order_detail"
                  @input="changePayDetailPlaceOrder" />
                %
                <span class="title">比例为0时表示不回传订单金额</span>
              </div>
            </div>
          </div>

          <div>
            <el-switch active-text="回传关键行为" v-model="editForm.action"
              @change="changOnSwi('action', 'actionBackhaulType', 'actionBackhaulBehaviorType', 'action_behavior_options')"></el-switch>
            <span class="hcbl_title" style="margin-left: 58px">回传比例
              <el-input class="back-money" :min="0" :max="100" type="number" v-model="editForm.actionNum"
                @input="changeActionNum" @blur="
                  editForm.actionNum === ''
                    ? (editForm.actionNum = 100)
                    : (editForm.actionNum = editForm.actionNum)
                  " />%
            </span>

            <div v-if="editForm.action" class="form-item-child">
              <span class="hcbl_title" style="padding:10px 0">
                <span class="hcbl_title" style="margin-right: 14px">回传类型</span>
                <!-- 回传选择 -->
                <el-select class="back-money" style="width:180px" v-model="editForm.actionBackhaulType"
                  @change="changeSwi('actionBackhaulBehaviorType')" placeholder="请选择">
                  <el-option v-for="item in type_options" :key="item.val" :label="item.label" :value="item.val">
                  </el-option>
                  <el-popover placement="right" width="100" trigger="hover">
                    <div>如果开启API映射回传则需要部门对接中台映射回传接口，开发相应功能</div>
                    <el-option :label="mapping_val.label" :value="mapping_val.val" slot="reference">
                    </el-option>
                  </el-popover>
                </el-select>
                <!-- 行为选择 -->
                <el-select class="back-money" v-if="editForm.actionBackhaulType === '3'" style="width:180px"
                  v-model="editForm.actionBackhaulBehaviorType" placeholder="请选择标准行为" @change="changeSelectDis">
                  <el-option v-for="item in action_behavior_options" :disabled="item.disabled" :key="item.val"
                    :label="item.label" :value="item.val">
                  </el-option>
                </el-select>
              </span>
              <!-- 计划ID -->
              <div class="program-id-wrapper">
                <span class="hcbl_title" style="width: 90px;">计划ID</span>
                <el-input v-model="editForm.callback_behaviour_bind_aid" placeholder="请使用回车分割！" :rows="4"
                  type="textarea" style="width: 600px;"></el-input>
              </div>


            </div>
            <div v-if="editForm.action" style="padding: 10px 0">
              <span class="hcbl_title form-item-child">
                <span class="hcbl_title" style="margin-right: 14px">自定义回传时间</span>
                <el-input class="back-money" :min="1" type="number" v-model="editForm.action_timeNum"
                  @input="changeActionTime" />
                <el-select class="back-money" v-model="editForm.action_time" placeholder="请选择">
                  <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </span>
            </div>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showEditForm = false">取 消</el-button>
        <el-button type="primary" @click="onEdit">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="批量回传控制" :visible.sync="dialogVisible" :close-on-click-modal="false" :before-close="handleClose"
      width="600px">
      <el-form :model="passback" style="text-align: center; padding: 0 25px" :rules="rules" ref="ruleForm">
        <el-form-item label-width="100px" label="选择应用：" style="display: inline-block" prop="appid">
          <el-select v-model="passback.appid" placeholder="请选择应用" filterable>
            <el-option v-for="item in apps" :key="item.id" :label="item.title" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="origin">
          <el-input type="textarea" :rows="10" placeholder="填入需批量操作的渠道，渠道间用回车隔开" v-model="passback.origin">
          </el-input>
        </el-form-item>
        <el-form-item>
          <div style="display: flex; justify-content: space-around">
            <el-button type="primary" @click="batchOff(1)">批量开</el-button>
            <el-button type="danger" @click="batchOff(0)">批量关</el-button>
          </div>
        </el-form-item>
        <el-form-item v-if="errInfo">
          <el-input type="textarea" :rows="10" placeholder="填入需批量操作的渠道，渠道间用（;）隔开" v-model="errInfo">
          </el-input>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { pickerOptions } from "@/config/option";
import FilterLayout from "@/layout/form";
import TableLayout from "@/layout/table";
import SelectApp from "@/component/select-app";
import { mapState } from "vuex";
import { formatSystem } from "@/util/filters";
import store from "store2";

import moment from "moment";

export default {
  name: "home",
  components: {
    FilterLayout,
    TableLayout,
    SelectApp,
  },
  computed: {
    ...mapState({
      App: (state) => state.app.data,
      orderCallbackType: (state) => state.dict_main.order_callback_type
    }),
  },
  data() {
    return {
      // showOrderType: false, // 是否展示订单类型
      flag: false,
      ceshi: true,
      pickerOptions,
      searchForm: {
        account_name: "",
        platform: "",
        app_id: "",
        time: [],
      },
      column: [
        {
          prop: "appid",
          label: "APPID",
        },
        {
          prop: "system",
          label: "系统",
        },
        {
          prop: "title",
          label: "APP名称",
        },
        {
          prop: "platform",
          label: "广告平台名称",
        },
        {
          prop: "channel",
          label: "渠道号",
        },
        {
          prop: "option",
          label: "操作",
        },
      ],
      tableOpt: {
        currentPage: 1,
        pageSize: 10,
      },
      tableData: {
        data: [],
        total: 0,
        loading: false,
        currentPage: 1,
        pageSize: 10,
      },
      showEditForm: false,
      editFormTitle: "",
      platform: [],
      platformFlag: '',
      editForm: {
        id: "",
        active: false,
        activeBackhaulType: "1",
        back_active_bind_aid: "", // 绑定的回传激活设备计划ID
        back_keep_bind_aid: "", // 激活回传计划ID
        back_pay_bind_aid: "", // 付费计划ID
        callback_behaviour_bind_aid: "", // 行为计划ID
        create_order_bind_aid: "",   // 订单计划ID
        activeBackhaulBehaviorType: "",
        active_timeNum: 1,
        active_time: "day",
        keep: false,
        keepBackhaulType: "1",
        keepBackhaulBehaviorType: "",
        keep_timeNum: 1,
        keep_time: "day",
        activation_check: 0,//激活回传效验
        keep_today: false,
        pay: false,
        payBackhaulType: "1",
        payBackhaulBehaviorType: "",
        pay_today: false,
        pay_money: 0,
        pay_detail: 0,
        a: 0, //回传付费设备
        b: 0, //自定义回传时间
        c: 0, //订单金额
        d: 1, //金额比例
        order: false, //回传下单设备
        orderBackhaulType: "1",
        orderBackhaulBehaviorType: "",
        order_today: false,
        order_money: 0,
        order_detail: 0,
        order_c: 0,
        order_d: 1,
        action: false,
        actionBackhaulType: "1",
        actionBackhaulBehaviorType: "",
        actionNum: 0,
        action_timeNum: 0,
        time: "day",
        time_order: "day",
        action_time: "day",
        order_callback_type: "1", // 订单类型
      },
      myEventId: "",
      options: [
        {
          value: "day",
          label: "日",
        },
        {
          value: "hour",
          label: "小时",
        },
      ],
      type_options: [
      ],
      behavior_options: [

      ],
      dialogVisible: false,
      apps: [],
      passback: {
        appid: "",
        origin: "",
      },
      errInfo: "",
      rules: {
        appid: [{ required: true, message: "请选择应用", trigger: "change" }],
        origin: [{ required: true, message: "请填写渠道", trigger: "change" }],
      },
      queryAppId: "",
      mapping_val: "",
    };
  },
  mounted() {
    if (this.$route.query.channel && this.$route.query.appid) {
      this.$nextTick(() => {
        this.searchForm.account_name = this.$route.query.channel;
        this.searchForm.app_id = this.$route.query.appid;
        this.onSubmit();
      });
    } else {
      this.fetchPlatform();
      this.fetchData();
    }
    this.handleData()
  },
  methods: {
    async fetchPlatform() {
      const [err, res] = await this.$http.post("Invest_Config/get", {
        cate: 10,
      });

      if (err) return;

      this.platform = res;
    },
    async fetchData() {
      const { searchForm, tableOpt } = this;

      this.tableData.loading = true;

      const [err, res] = await this.$http.post(
        "Invest_Config/backControlList",
        {
          ...searchForm,
          ...tableOpt,
          timeBegin: this.searchForm.time[0],
          timeEnd: this.searchForm.time[1],
          cate: 10,
        }
      );

      this.tableData.loading = false;

      if (err) return;

      const { list, currentPage, total } = res;
      this.tableData.data = list;
      this.tableData.currentPage = currentPage;
      this.tableData.total = total;
      if (this.$route.query.channel && this.$route.query.appid) {
        this.onShowEdit(this.tableData.data[0]);
      }
    },
    onSubmit() {
      this.tableOpt.currentPage = 1;
      this.fetchData();
    },
    onPageChange(current) {
      this.tableOpt.currentPage = current;
      this.fetchData();
    },
    onSizeChange(current) {
      this.tableOpt.pageSize = current;
      this.fetchData();
    },
    async onShowEdit(data) {
      this.handleData()
      const { title, system, platform, id, channel } = data;
      this.editFormTitle = `${title}(${formatSystem(system)}) - ${platform} - ${channel}`;
      this.showEditForm = true;
      this.platformFlag = platform;
      console.log(platform);
      const [err, res] = await this.$http.post(
        "Invest_Config/queryCallbackConf",
        {
          id,
        }
      );
      let back_control = res.conf
      this.editForm.activeBackhaulBehaviorType = "";
      this.editForm.keepBackhaulBehaviorType = "";
      this.editForm.payBackhaulBehaviorType = "";
      this.editForm.orderBackhaulBehaviorType = "";
      this.editForm.actionBackhaulBehaviorType = "";
      for (const key in back_control) {
        if (key === "back_active") {
          // 判断字段是否存在,不存在给予默认值
          if (back_control[key].callback_cate) {
            // 判断是否为数字,数字为一级菜单，字符串为2级
            if (!isNaN(parseFloat(Number(back_control[key].callback_cate))) && isFinite(Number(back_control[key].callback_cate))) {
              this.editForm.activeBackhaulType = String(back_control[key].callback_cate)
            } else {
              this.active_behavior_options.forEach(item => {
                if (item.val == back_control[key].callback_cate) {
                  item.disabled = true
                }
              })
              this.editForm.activeBackhaulBehaviorType = back_control[key].callback_cate
              this.editForm.activeBackhaulType = "3"
            }
          } else {
            this.editForm.activeBackhaulType = "1"
          }
        }
        if (key === "back_keep") {
          if (back_control[key].callback_cate) {
            if (!isNaN(parseFloat(Number(back_control[key].callback_cate))) && isFinite(Number(back_control[key].callback_cate))) {
              this.editForm.keepBackhaulType = String(back_control[key].callback_cate)
            } else {
              this.keep_behavior_options.forEach(item => {
                if (item.val == back_control[key].callback_cate) {
                  item.disabled = true
                }
              })
              this.editForm.keepBackhaulBehaviorType = back_control[key].callback_cate
              this.editForm.keepBackhaulType = "3"
            }
          } else {
            this.editForm.keepBackhaulType = "1"
          }
        }
        if (key === "back_pay") {
          if (back_control[key].callback_cate) {
            if (!isNaN(parseFloat(Number(back_control[key].callback_cate))) && isFinite(Number(back_control[key].callback_cate))) {
              this.editForm.payBackhaulType = String(back_control[key].callback_cate)
            } else {
              this.pay_behavior_options.forEach(item => {
                if (item.val == back_control[key].callback_cate) {
                  item.disabled = true
                }
              })
              this.editForm.payBackhaulBehaviorType = back_control[key].callback_cate
              this.editForm.payBackhaulType = "3"
            }
          } else {
            this.editForm.payBackhaulType = "1"
          }
        }
        if (key === "create_order") {
          if (back_control[key].callback_cate) {
            if (!isNaN(parseFloat(Number(back_control[key].callback_cate))) && isFinite(Number(back_control[key].callback_cate))) {
              this.editForm.orderBackhaulType = String(back_control[key].callback_cate)
            } else {
              this.order_behavior_options.forEach(item => {
                if (item.val == back_control[key].callback_cate) {
                  item.disabled = true
                }
              })
              this.editForm.orderBackhaulBehaviorType = back_control[key].callback_cate
              this.editForm.orderBackhaulType = "3"
            }
          } else {
            this.editForm.orderBackhaulType = "1"
          }
        }
        if (key === "callback_behaviour") {
          if (back_control[key].callback_cate) {

            if (!isNaN(parseFloat(Number(back_control[key].callback_cate))) && isFinite(Number(back_control[key].callback_cate))) {
              this.editForm.actionBackhaulType = String(back_control[key].callback_cate)
            } else {
              this.action_behavior_options.forEach(item => {
                if (item.val == back_control[key].callback_cate) {
                  item.disabled = true
                }
              })
              this.editForm.actionBackhaulBehaviorType = back_control[key].callback_cate
              this.editForm.actionBackhaulType = "3"
            }
          } else {
            this.editForm.actionBackhaulType = "1"
          }
        }
      }
      // debugger
      this.$nextTick(() => {
        this.editForm.action = back_control.callback_behaviour ? !!Number(back_control.callback_behaviour.on) : false;
        this.editForm.actionNum = back_control.callback_behaviour ? back_control.callback_behaviour.scale : 100;
        this.editForm.callback_behaviour_bind_aid = back_control.callback_behaviour.bind_aid ? back_control.callback_behaviour.bind_aid.join('\n') : "";
        this.editForm.action_timeNum =
          back_control.callback_behaviour ? back_control.callback_behaviour.custom_back_time.value : "24";
        this.editForm.action_time =
          back_control.callback_behaviour ? back_control.callback_behaviour.custom_back_time.unit : "hour";
        this.editForm.order_callback_type = back_control.back_pay.order_callback_type ? back_control.back_pay.order_callback_type + '' : '1'
        this.editForm.event_id = back_control.callback_behaviour.event_id
        this.editForm.id = id;
        this.editForm.active = !!Number(back_control.back_active.on);
        // 处理计划ID数据
        this.editForm.back_active_bind_aid = back_control.back_active.bind_aid ? back_control.back_active.bind_aid.join('\n') : ""
        this.editForm.active_timeNum =
          back_control.back_active.custom_back_time.value ? back_control.back_active.custom_back_time.value : "1";
        this.editForm.active_time =
          back_control.back_active.custom_back_time.unit ? back_control.back_active.custom_back_time.unit : "day";
        this.editForm.keep = !!Number(back_control.back_keep.on);
        this.editForm.keep_timeNum =
          back_control.back_keep.custom_back_time ? back_control.back_keep.custom_back_time.value : "1";
        this.editForm.keep_time =
          back_control.back_keep.custom_back_time ? back_control.back_keep.custom_back_time.unit : "day";
        // 处理计划ID数据
        this.editForm.back_keep_bind_aid = back_control.back_keep.bind_aid ? back_control.back_keep.bind_aid.join('\n') : ""
        this.editForm.activation_check = !!Number(back_control.back_keep.activation_check);
        this.editForm.pay = !!Number(back_control.back_pay.on);
        this.editForm.pay_today = !!Number(back_control.back_pay.today);
        this.editForm.pay_detail = back_control.back_pay.pay_detail;
        // 处理计划ID数据
        this.editForm.back_pay_bind_aid = back_control.back_pay.bind_aid ? back_control.back_pay.bind_aid.join('\n') : ""
        this.editForm.pay_money = back_control.back_pay.pay_fee;
        this.editForm.a = back_control.back_active.scale;
        this.editForm.b = back_control.back_keep.scale;
        this.editForm.c = back_control.back_pay.scale;
        this.editForm.order = !!Number(back_control.create_order.on);
        this.editForm.order_today = !!Number(back_control.create_order.today);
        this.editForm.order_detail = back_control.create_order.pay_detail;
        // 处理计划ID数据
        this.editForm.create_order_bind_aid = back_control.create_order.bind_aid ? back_control.create_order.bind_aid.join('\n') : ""
        this.editForm.order_money = back_control.create_order.pay_fee;
        this.editForm.order_c = back_control.create_order.scale;
        this.editForm.d = back_control.back_pay.custom_back_time.value;
        this.editForm.order_d = back_control.create_order.custom_back_time.value;
        this.editForm.time = back_control.back_pay.custom_back_time.unit;
        this.editForm.time_order = back_control.create_order.custom_back_time.unit;
      })
      this.changeSelectDis()

    },
    async onEdit() {
      // 判断回传按钮开启并且回传类型为映射回传时，二级下拉框有没有选择
      let {
        id,
        active,
        keep,
        pay,
        pay_money,
        pay_detail,
        a,
        activeBackhaulType,
        activeBackhaulBehaviorType,
        b,
        keepBackhaulType,
        keepBackhaulBehaviorType,
        activation_check,
        c,
        payBackhaulType,
        payBackhaulBehaviorType,
        order,
        order_money,
        order_detail,
        orderBackhaulType,
        orderBackhaulBehaviorType,
        order_c,
        d,
        order_d,
        actionBackhaulType,
        actionBackhaulBehaviorType,
        time,
        time_order,
        action,
        actionNum,
        action_timeNum,
        action_time,
        order_callback_type,
        event_id,
        active_time,
        active_timeNum,
        keep_time,
        keep_timeNum,
        back_active_bind_aid,
        back_keep_bind_aid,
        back_pay_bind_aid,
        callback_behaviour_bind_aid,
        create_order_bind_aid
      } = this.editForm;
      // console.log(keepBackhaulType,'xxsss',activeBackhaulType)
      let conf = {
        back_active: {
          on: active ? 1 : 0,
          scale: a,
          bind_aid: back_active_bind_aid ? back_active_bind_aid.split('\n') : [],
          callback_cate: activeBackhaulType === "3" ? activeBackhaulBehaviorType : activeBackhaulType,  // 如果选择了映射回传标准行为就使用标准行为的字段
          custom_back_time: {
            unit: active_time,
            value: active_timeNum
          },
        },
        back_keep: {
          on: keep ? 1 : 0,
          scale: b,
          bind_aid: back_keep_bind_aid ? back_keep_bind_aid.split('\n') : [],
          callback_cate: keepBackhaulType === "3" ? keepBackhaulBehaviorType : keepBackhaulType,
          activation_check: activation_check ? 1 : 0,
          custom_back_time: {
            unit: keep_time,
            value: keep_timeNum
          },
        },
        back_pay: {
          on: pay ? 1 : 0,
          scale: c,
          bind_aid: back_pay_bind_aid ? back_pay_bind_aid.split('\n') : [],
          pay_fee: Number(pay_money).toFixed(2),
          pay_detail: pay_detail,
          order_callback_type,
          custom_back_time: {
            unit: time,
            value: d,
          },
          callback_cate: payBackhaulType === "3" ? payBackhaulBehaviorType : payBackhaulType,
        },
        create_order: {
          on: order ? 1 : 0,
          scale: order_c,
          pay_fee: Number(order_money).toFixed(2),
          pay_detail: order_detail,
          custom_back_time: {
            unit: time_order,
            value: order_d,
          },
          bind_aid: create_order_bind_aid ? create_order_bind_aid.split('\n') : [],
          callback_cate: orderBackhaulType === "3" ? orderBackhaulBehaviorType : orderBackhaulType,
        },
        callback_behaviour: {
          on: action ? 1 : 0,
          scale: actionNum,
          custom_back_time: {
            unit: action_time,
            value: action_timeNum,
          },
          bind_aid: callback_behaviour_bind_aid ? callback_behaviour_bind_aid.split('\n') : [],
          event_id: event_id ? event_id : 0,
          callback_cate: actionBackhaulType === "3" ? actionBackhaulBehaviorType : actionBackhaulType,
        }
      }
      const newArr = Object.values(conf)
      let errArr = []
      newArr.forEach(item => {
        if (item.on && !item.callback_cate) {
          errArr.push(item)
        }
      })
      if (errArr.length) {
        this.$message.error('请选择标准行为');
        return
      }
      if (!id) return;

      const [err, res] = await this.$http.post(
        "Invest_Config/editBackControl",
        {
          // 为了合并dev加的注释
          id: id,
          conf: conf
        }
      );

      if (err) {
        // this.$message.error("编辑失败");

        return;
      }

      this.$message.success("编辑成功");

      this.showEditForm = false;
      this.fetchData();
      this.handleData()
    },
    formatPut(code) {
      switch (String(code)) {
        case "":
          return "全部";
        case "1":
          return "是";
        case "2":
          return "否";
        default:
          return "未知";
      }
    },
    changeNum(data) {
      if (data > 100) {
        this.editForm.a = 100;
      }
      if (data < 0) {
        this.editForm.a = 0;
      }
    },
    changeNum2(data) {
      if (data > 100) {
        this.editForm.b = 100;
      }
      if (data < 0) {
        this.editForm.b = 0;
      }
    },
    changeNum3(data) {
      if (data > 100) {
        this.editForm.c = 100;
      }
      if (data < 0) {
        this.editForm.c = 0;
      }
    },
    changeNum4(data) {
      if (data > 100) {
        this.editForm.order_c = 100;
      }
      if (data < 0) {
        this.editForm.order_c = 0;
      }
    },
    changeActionNum(data) {
      if (data > 100) {
        this.editForm.actionNum = 100;
      }
      if (data < 0) {
        this.editForm.actionNum = 0;
      }
    },
    changeTimeNum(data) {
      if (data < 0) {
        this.editForm.d = 0;
      }
      this.editForm.d = data.replace(/[^\d]/g, "");
    },
    changeTimeNumPlaceOrder(data) {
      if (data < 0) {
        this.editForm.order_d = 0;
      }
      this.editForm.order_d = data.replace(/[^\d]/g, "");
    },
    changeActionTime(data) {
      if (data < 0) {
        this.editForm.action_timeNum = 0;
      }
      this.editForm.action_timeNum = data.replace(/[^\d]/g, "");
    },
    changeActiveTime(data) {
      if (data < 0) {
        this.editForm.active_timeNum = 0;
      }
      this.editForm.active_timeNum = data.replace(/[^\d]/g, "");
    },
    changeKeepTime(data) {
      if (data < 0) {
        this.editForm.keep_timeNum = 0;
      }
      this.editForm.keep_timeNum = data.replace(/[^\d]/g, "");
    },
    changePayDetail(data) {
      if (data < 0) {
        this.editForm.pay_detail = 0;
        return;
      }
      if (data > 100) {
        this.editForm.pay_detail = 100;
        return;
      }
      this.editForm.pay_detail = data.replace(/[^\d]/g, "");
    },
    changePayDetailPlaceOrder(data) {
      if (data < 0) {
        this.editForm.order_detail = 0;
        return;
      }
      if (data > 100) {
        this.editForm.order_detail = 100;
        return;
      }
      this.editForm.order_detail = data.replace(/[^\d]/g, "");
    },
    async onConfirm(row) {
      const [err, res] = await this.$http.post(
        "Invest_Config/batchBackControl",
        {
          appid: row.appid,
          origin: [row.channel],
          switch: row.status == "1" ? 0 : 1,
        }
      );
      if (res.length == 0) {
        this.$message({
          message: "保存成功",
          type: "success",
        });
      }
      this.fetchData();
    },
    async openPassback() {
      this.dialogVisible = true;
      const [err, res] = await this.$http.post("System/roleBtree");
      if (err) return;
      this.department_id = res.tree;
      res.list.forEach((item) => {
        if (item.title == "应用") {
          item.node.forEach((_item) => {
            if (_item.system == "1") {
              _item.title = _item.title + "_Android";
            } else if (_item.system == "2") {
              _item.title = _item.title + "_IOS";
            } else if (_item.system == "3") {
              _item.title = _item.title + "_微信小程序";
            }
          });
        }
      });
      let apps = [];
      res.tree.forEach((item) => {
        item.node.forEach((_item) => {
          _item.node.forEach((__item) => {
            apps.push(...__item.node);
          });
        });
      });
      this.apps = apps;
    },
    batchOff(val) {
      this.$refs["ruleForm"].validate(async (valid) => {
        if (valid) {
          const [err, res] = await this.$http.post(
            "Invest_Config/batchBackControl",
            {
              appid: this.passback.appid,
              origin: this.passback.origin.split("\n"),
              switch: val,
            }
          );
          if (err) {
            return;
          }
          if (res.length) {
            this.$message.error("保存失败,请确认渠道");
            if (res.length == 1) {
              this.errInfo = res.join("");
            } else {
              this.errInfo = res.join("\n");
            }
          } else {
            this.$message({
              message: "修改成功",
              type: "success",
            });
            this.errInfo = "";
            this.$refs["ruleForm"].resetFields();
            this.dialogVisible = false;
            this.fetchData();
            this.errInfo = "";
          }
        } else {
          return false;
        }
      });
    },
    changeSwi(prop) {
      this.editForm[prop] = ""
      this.changeSelectDis()
    },
    changOnSwi(flag, prop1, prop2, arr) {
      if (!this.editForm[flag]) {
        this.active_behavior_options.forEach(item => {
          if (item.val === this.editForm[prop2]) {
            item.disabled = false
          }
        })
        this.keep_behavior_options.forEach(item => {
          if (item.val === this.editForm[prop2]) {
            item.disabled = false
          }
        })
        this.pay_behavior_options.forEach(item => {
          if (item.val === this.editForm[prop2]) {
            item.disabled = false
          }
        })
        this.order_behavior_options.forEach(item => {
          if (item.val === this.editForm[prop2]) {
            item.disabled = false
          }
        })
        this.action_behavior_options.forEach(item => {
          if (item.val === this.editForm[prop2]) {
            item.disabled = false
          }
        })
        this.editForm[prop1] = "1"
        this.editForm[prop2] = ""
      }
      if (flag == 'pay') {
        this.editForm.order_callback_type = this.editForm.order_callback_type ? this.editForm.order_callback_type : "1"
        this.editForm.c = this.editForm.c ? this.editForm.c : 0 //订单金额
        this.editForm.d = this.editForm.d ? this.editForm.d : 1 //金额比例
      }
      if (flag == 'order') {
        this.editForm.order_c = this.editForm.order_c ? this.editForm.order_c : 0 //订单金额
        this.editForm.order_d = this.editForm.order_d ? this.editForm.order_d : 1 //金额比例
      }
    },
    handleClose() {
      this.errInfo = "";
      this.$refs["ruleForm"].resetFields();
      this.dialogVisible = false;
    },
    showDetails(index) {
      this.showPopover = true;
      this.popoverVisible = true;
    },
    hideDetails() {
      this.showPopover = false;
      this.popoverVisible = false;
    },
    // 处理字典数据
    handleData() {
      this.active_behavior_options = []
      this.keep_behavior_options = []
      this.pay_behavior_options = []
      this.order_behavior_options = []
      this.action_behavior_options = []
      let type_options = []; //一级菜单
      let behavior_options = [] //二级菜单
      let mapping_val = ""; //有浮窗的下拉框
      let newArr = JSON.parse(JSON.stringify(this.$store.state.dict_main.callback_cate))
      let arr = newArr.sort((a, b) => { return a.id - b.id }) //通过ID进行排序
      arr.forEach(item => {
        if (item.label === "API映射回传（非标准行为）") {
          mapping_val = item
          return
        }
        if (!isNaN(parseFloat(Number(item.val))) && isFinite(Number(item.val))) {
          type_options.push(item)
        } else {
          behavior_options.push(item)
        }
      })
      type_options.splice(1, 0, {
        label: "映射回传（标准行为）",
        val: '3',
      })
      // 回传激活设备的标准行为数组
      let active_behavior_options = []
      // 回传次日留存的标准行为数组
      let keep_behavior_options = []
      // 回传付费设备的标准行为数组
      let pay_behavior_options = []
      // 回传下单设备的标准行为数组
      let order_behavior_options = []
      // 回传关键行为的标准行为数组
      let action_behavior_options = []

      behavior_options.forEach(item => {
        // 只有回传次日留存 回传付费设备 回传关键行为拥有激活下拉选项
        if (item.label == "激活") {
          keep_behavior_options.push(item)
          pay_behavior_options.push(item)
          order_behavior_options.push(item)
          action_behavior_options.push(item)
          return
        }
        if (item.label == "次留") {
          active_behavior_options.push(item)
          pay_behavior_options.push(item)
          order_behavior_options.push(item)
          action_behavior_options.push(item)
          return
        }
        if (item.id == "88" || item.id == "89" || item.id == "90") {
          active_behavior_options.push(item)
          keep_behavior_options.push(item)
          order_behavior_options.push(item)
          action_behavior_options.push(item)
          return
        }
        active_behavior_options.push(item)
        keep_behavior_options.push(item)
        pay_behavior_options.push(item)
        order_behavior_options.push(item)
        action_behavior_options.push(item)
      })

      this.type_options = JSON.parse(JSON.stringify(type_options));
      this.active_behavior_options = JSON.parse(JSON.stringify(active_behavior_options));
      this.keep_behavior_options = JSON.parse(JSON.stringify(keep_behavior_options));
      this.pay_behavior_options = JSON.parse(JSON.stringify(pay_behavior_options));
      this.order_behavior_options = JSON.parse(JSON.stringify(order_behavior_options));
      this.action_behavior_options = JSON.parse(JSON.stringify(action_behavior_options));
      this.mapping_val = mapping_val
    },
    // 如果下拉列表有相同的数据禁用
    changeSelectDis(val) {
      let arr = ['activeBackhaulBehaviorType', 'keepBackhaulBehaviorType', 'payBackhaulBehaviorType', 'orderBackhaulBehaviorType', 'actionBackhaulBehaviorType']
      this.behavior_options.forEach((item, index) => {
        // 全部置空
        item.disabled = false;
      })
      this.active_behavior_options.forEach((item, index) => {
        // 全部置空
        item.disabled = false;
      })
      this.keep_behavior_options.forEach((item, index) => {
        // 全部置空
        item.disabled = false;
      })
      this.pay_behavior_options.forEach((item, index) => {
        // 全部置空
        item.disabled = false;
      })
      this.order_behavior_options.forEach((item, index) => {
        // 全部置空
        item.disabled = false;
      })
      this.action_behavior_options.forEach((item, index) => {
        // 全部置空
        item.disabled = false;
      })

      arr.forEach(el => {
        const val = this.editForm[el]
        for (let item of this.active_behavior_options) {
          if (val == item.val) {
            item.disabled = true
          } else {
            // item.disabled = false
          }
        }
        for (let item of this.keep_behavior_options) {
          if (val == item.val) {
            item.disabled = true
          } else {
            // item.disabled = false
          }
        }
        for (let item of this.pay_behavior_options) {
          if (val == item.val) {
            item.disabled = true
          } else {
            // item.disabled = false
          }
        }
        for (let item of this.order_behavior_options) {
          if (val == item.val) {
            item.disabled = true
          } else {
            // item.disabled = false
          }
        }
        for (let item of this.action_behavior_options) {
          if (val == item.val) {
            item.disabled = true
          } else {
            // item.disabled = false
          }
        }
      })
      /*       let arr_val = []
            arr.forEach(el => {
              arr_val.push(this.editForm[el])
            })
            for (let item of this.active_behavior_options) {
              if (arr_val.indexOf(item.val) > -1) {
                item.disabled = true
              } else {
                item.disabled = false
              }
            }
            for (let item of this.keep_behavior_options) {
              if (arr_val.indexOf(item.val) > -1) {
                item.disabled = true
              } else {
                item.disabled = false
              }
            }
            for (let item of this.pay_behavior_options) {
              if (arr_val.indexOf(item.val) > -1) {
                item.disabled = true
              } else {
                item.disabled = false
              }
            }
            for (let item of this.action_behavior_options) {
              if (arr_val.indexOf(item.val) > -1) {
                item.disabled = true
              } else {
                item.disabled = false
              }
            } */


    }
  },
  watch: {
    editForm: {
      handler(newName, oldName) {
        this.myEventId = this.editForm.event_id
      },
      deep: true
    }
  }
};
</script>

<style lang="less" scoped>
.form-item-child {
  padding-left: 20px;
}

/deep/.back-money {
  width: 100px;
  margin: 0 10px;
}

.hcbl_title {
  display: inline-block;
}

.title {
  display: inline-block;
  margin-left: 20px;
  font-size: 12px;
  color: #aaaaaa;
}

/deep/.el-dialog__body {
  padding: 0 20px 15px 20px;
}

.program-id-wrapper {
  display: flex;
}
</style>
